import { Box, Button } from "@chakra-ui/react";
import { ReactNode, useEffect, useRef, useState } from "react";

export function Code1({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);
  const expandRef = useRef<HTMLButtonElement>(null);
  const collapseRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setMounted(true);
    if (
      !(
        mounted &&
        parentRef.current &&
        expandRef.current &&
        collapseRef.current
      )
    )
      return;

    const [collapsed, expanded] = Array.from(
      parentRef.current!.children,
    ) as HTMLElement[];

    const onExpand = () => {
      collapsed.style.display = "none";
      expanded.style.display = "block";
    };

    const onCollapse = () => {
      collapsed.style.display = "block";
      expanded.style.display = "none";
    };

    onCollapse();

    Array.from(collapsed.children).map((child) => {
      const expandButton = expandRef.current!.cloneNode(
        true,
      ) as HTMLButtonElement;
      child.children[0].children[1].children[7].replaceWith(expandButton);
      expandButton.style.display = "inline-block";
      expandButton.addEventListener("click", onExpand);
    });

    Array.from(expanded.children).map((child) => {
      const collapseButton = collapseRef.current!.cloneNode(
        true,
      ) as HTMLButtonElement;
      Array.from(child.children[0].children)
        .at(-1)
        ?.insertAdjacentElement("beforebegin", collapseButton);
      collapseButton.style.display = "inline-block";
      collapseButton.addEventListener("click", onCollapse);
      collapseButton.insertAdjacentText("beforebegin", "  ");
      collapseButton.insertAdjacentElement(
        "afterend",
        document.createElement("br"),
      );
    });
  }, [mounted]);

  return (
    <Box ref={parentRef}>
      {children}
      <Button
        ref={expandRef}
        colorScheme="blue"
        display="none"
        variant="outline"
        size="xs"
        mt="-0.5"
      >
        expand
      </Button>
      <Button
        ref={collapseRef}
        colorScheme="blue"
        display="none"
        variant="outline"
        size="xs"
      >
        collapse
      </Button>
    </Box>
  );
}
